window.daterangepicker_locales = {
    'lt': {
        'separator': ' - ',
        'applyLabel': 'Taikyti',
        'cancelLabel': 'Atšaukti',
        'fromLabel': 'Nuo',
        'toLabel': 'Iki',
        'customRangeLabel': 'Pasirinktinas',
        'weekLabel': 'Sav.',
        'daysOfWeek': [
            'S.',
            'P.',
            'A',
            'T',
            'K',
            'Pn',
            'Š'
        ],
        'monthNames': [
            'Sausis',
            'Vasaris',
            'Kovas',
            'Balandis',
            'Gegužė',
            'Birželis',
            'Liepa',
            'Rugpjūtis',
            'Rugsėjis',
            'Spalis',
            'Lapkritis',
            'Gruodis'
        ],
        'firstDay': 1
    },
    'en': {
        'format': 'MM/DD/YYYY',
        'separator': ' - ',
        'applyLabel': 'Apply',
        'cancelLabel': 'Cancel',
        'fromLabel': 'From',
        'toLabel': 'To',
        'customRangeLabel': 'Custom',
        'weekLabel': 'W',
        'daysOfWeek': [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        'monthNames': [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        'firstDay': 1
    }
};